module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "zk-form",
    class: [_vm.labelPosition ? 'zk-form--label-' + _vm.labelPosition : '', {
      'zk-form--inline': _vm.inline
    }],
    attrs: {
      "action": _vm.action,
      "method": _vm.method
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-3e84d882"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/form/src/form.vue
// module id = 249
// module chunks = 0